import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { promoCodeQKeys } from "@hooks/queries/promocodes/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { CreatePromoCodeData } from "@customTypes/promoCode";


export const useCreatePromoCode = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (promoCodeData: CreatePromoCodeData) => {
      return api.post("promocodes/", {
        code: promoCodeData.code,
        discount_percent: promoCodeData.discountPercent,
        valid_from: promoCodeData.validFrom.toISOString(),
        valid_until: promoCodeData.validUntil.toISOString(),
        services: promoCodeData.services,
        medical_professional: promoCodeData.medicalProfessional,
        max_uses: promoCodeData.maxUses,
        current_uses: 0,
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "create-promo-code-success",
      });

      // Invalidate promo codes query to refetch the updated list
      queryClient.invalidateQueries({
        queryKey: promoCodeQKeys.all(),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Promo Code]", res);
      handleErrors(res, "mutation");
    },
  });
};
